import type { IGameCommunicationProcessor } from '../types';

export class GameCommunicationBetsClosingSoonProcessor implements IGameCommunicationProcessor {
  messageName = 'betsclosingsoon';
  delay = 0;

  process(): void {
    return;
  }
}
